import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const totalCount = useSelector((state) => state.cart.totalCount);

  return (
    <header className="header">
      <nav>
        <Link to="/">Home</Link>
        <Link to="/products">Products</Link>
        <Link to="/cart" className="cart-link">
          Cart 🛒
          <span className="cart-count">{totalCount}</span>
        </Link>
      </nav>
    </header>
  );
}

export default Header;


